export default class LoginService {
  /* @ngInject */
  constructor(HttpService, AuthService) {
    this.httpService = HttpService;
    this.authService = AuthService;
  }

  createADFSUrl(action = 'login') {
    const waAction = action === 'login' ? 'in' : 'out';
    const wreply = encodeURIComponent(`${this.httpService.BASE_PATH}/adfs/${action}`);
    const wtrealm = encodeURIComponent(this.httpService.BASE_PATH);
    const wa = encodeURIComponent(`wsign${waAction}1.0`);
    return `${window.__FHL__.host.adfs}/adfs/ls?wreply=${wreply}&wtrealm=${wtrealm}&wa=${wa}`;
  }

  createJWT(sha1) {
    return this.httpService({
      method: 'POST',
      url: `${this.httpService.BASE_PATH}/adfs/${sha1}/decoded`,
    }).then(response => response.data.data, (error) => {
      this.logout();
      return this.httpService.reject(error);
    });
  }

  logout() {
    this.authService.token(null);
    window.open(this.createADFSUrl('logout'), '_self');
  }

  getTermsAndConditions(username) {
    return this.httpService({
      method: 'GET',
      url: `${window.__FHL__.host.termsAndConditions}/${username}`,
    }).then(response => response.data.data, this.httpService.reject);
  }

  saveTermsAndConditions(data) {
    return this.httpService({
      method: 'POST',
      url: window.__FHL__.host.termsAndConditions,
      data: {data},
    }).then(response => response.data.data, this.httpService.reject);
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.service.js